module.exports = __webpack_public_path__ + "img/AstroFrens207.847f2ba0.jpg";